import React from 'react';
import type IssueHierarchyDirectory from '@atlassian/jira-spa-apps-admin-pages-issue-hierarchy-directory/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyIssueHierarchyDirectory = lazyForPaint<typeof IssueHierarchyDirectory>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-admin-pages-issue-hierarchy-directory", jiraSpaEntry: "async-admin-pages-issue-hierarchy-directory" */ '@atlassian/jira-spa-apps-admin-pages-issue-hierarchy-directory'
		),
	),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage
		Page={LazyIssueHierarchyDirectory}
		pageId="jira-admin-pages-issue-hierarchy-directory"
		shouldShowSpinner
	/>
);
